// noinspection JSUnresolvedFunction

import {Browser} from "./Browser";
import {Display} from "./Display";
import {Slider} from "./Slider";

// noinspection JSUnresolvedVariable
export class Basic
{
    static init()
    {
        Basic.base = '/';
        Basic.resizeTimer = 0;
        Basic.scrollTimer = 0;
    }

    static update_page(r)
    {
        document.title = r['pageTitle'];

        const div = document.createElement('div'),
              container = document.getElementById('container');
        div.classList.add('iLoad-frame');
        div.innerHTML = r['html'];
        div.style.width = container.getBoundingClientRect()['width'].toString() + 'px';
        div.style.minHeight = container.getBoundingClientRect()['height'].toString() + 'px';
        div.style.transform = 'translateY(100vh)';
        div.style.top = container.getBoundingClientRect()['top'].toString() + 'px';
        div.style.left = container.getBoundingClientRect()['left'].toString() + 'px';
        div.style.margin = '0';

        document.body.appendChild(div);

        div.offsetHeight;
        div.style.transform = '';

        let activeMenu = document.getElementById('menu').querySelector('li.active');
        if(activeMenu)
        {
            activeMenu.classList.remove('active');
        }
        activeMenu = document.getElementById('menu').querySelector('li.r-' + r['path']);
        if(activeMenu)
        {
            activeMenu.classList.add('active');
        }

        document.body.className = r['bodyClass'];
        if(Browser.mobile === true)
        {
            document.body.classList.remove('no-touch');
        }

        setTimeout(() => {
            container.remove();
            div.id = 'container';
            div.classList.remove('iLoad-frame');
            div.removeAttribute('style');

            document.documentElement.style.scrollBehavior = 'auto';
            document.documentElement.scrollTo(0, 0);
            document.documentElement.style.scrollBehavior = '';

            // start slideshow
            new Slider();
        },500);

        Basic.do_afterLoad();
    }

    static do_afterLoad()
    {
        /*
        const googlemap = document.body.querySelector('.link.googlemap');
        if(googlemap)
        {
            Basic.load_googlemapApi(googlemap);
        }
         */
    }

/*
    static load_googlemapApi = function(el)
    {
        const myLibrary = document.createElement('script');
        myLibrary.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCfh7CZHcBLIxfm3_vEJaz9VgrUVbDUkUg';
        myLibrary.onload = () =>
        {
            Basic.insert_googlemap(el);
        };
        document.head.appendChild(myLibrary);
    }

    static insert_googlemap = function(el)
    {
        if(el.dataset.l1 && el.dataset.l2)
        {
            const myMapCanvas = document.createElement('div');
            myMapCanvas.id = 'map_canvas';
            el.insertAdjacentElement('afterend',myMapCanvas);

            const latlng = new google.maps.LatLng(el.dataset.l1, el.dataset.l2),
                  myOptions = {zoom: 16, center: latlng, mapTypeId: google.maps.MapTypeId.ROADMAP},
                  map = new google.maps.Map(myMapCanvas, myOptions),
                  graustufen = [{featureType: 'all', stylers: [{saturation: -100}, {gamma: 0.90}]}],
                  marker = new google.maps.Marker({
                    position: latlng,
                    map: map,
                    icon: Basic.base + 'lib/pix/e-marke-klein.' + (Browser.engine === 'trident' || Browser.engine === 'edgehtml'
                                    ? 'png' : 'svg')
                });
            el.remove();

            map.setOptions({styles: graustufen, disableDefaultUI: true});
            marker.setMap(map);
        }
    }
 */

    static process_resize()
    {
        Display.analyze();
    }

    static process_scroll()
    {
        if(document.body.classList.contains('home'))
        {
            document.getElementById('header').style.position = 'fixed';

            // noinspection JSDeprecatedSymbols
            const scrollY = window.scrollY || window.pageYOffset;
            let headerHeight = Display.y / 2,
                logoHeight = headerHeight - scrollY;

            if(logoHeight <= 90)
            {
                logoHeight = 90;
            }

            document.documentElement.style.setProperty('--logo-height',
                                           logoHeight.toString() + 'px');
            document.documentElement.style.setProperty('--opacity',
                                            ((logoHeight - 90) / (headerHeight - 90)).toString());
        }
        else
        {
            document.getElementById('header').style.position = '';
        }
    }

    static build_video(el)
    {
        const iFrame = Basic.build_iFrame(Basic.get_iFrameSrc(el,'1'),'w__video');
        el.insertAdjacentElement('beforebegin', iFrame);
        el.remove();
    }

    static build_iFrame(mySrc, myClass)
    {
        const myIframe = document.createElement('iframe');
        myIframe.src = mySrc;
        myIframe.classList.add(myClass);
        myIframe.frameborder = 0;
        myIframe.allowfullscreen = 1;
        myIframe.setAttribute('allow','autoplay; fullscreen');
        return myIframe;
    }

    static get_iFrameSrc(videoEl, autoplay)
    {
        let url = videoEl.href ? videoEl.href : videoEl.dataset.url;
        switch(videoEl.dataset.videoType)
        {
            case 'youtube':
                url = 'https://www.youtube-nocookie.com/embed/' +
                    videoEl.dataset.videoCode +
                    '?showinfo=0' +
                    '&controls=1' +
                    '&fs=1' +
                    '&rel=0' +
                    '&hl=' + Basic.lang +
                    '&autoplay=' + autoplay +
                    '&modestbranding=1' +
                    '&showsearch=0';
                break;

            case 'vimeo':
                url = 'https://player.vimeo.com/video/' + videoEl.dataset.videoCode +
                    '?autoplay=' + autoplay +
                    '&badge=0' +
                    '&byline=0' +
                    '&portrait=0' +
                    '&title=0' +
                    '&dnt=1';
                break;

            default:
                alert('Unknown video type');
        }
        return url;
    }
}

